import { LogOut, ChartNoAxesGantt, LayoutDashboard, Contact, AudioWaveform } from 'lucide-react';
// import Projects from './Projects';
// import Dashboard from './Dashboard';
import { AlignJustify } from 'lucide-react';
import { Link, NavLink } from 'react-router-dom';

import { useState, useRef, useEffect } from 'react';

const Header = (props) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };

        if (menuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [menuOpen]);

    return (
        <>
            <header className='px-5 py-2 w-full'>
                <span className="font-Tsukimi font-semibold ml-0 mb-1">mixbus</span>
                <menu id="menu-main" className='flex gap-5'>
                    <NavLink to="/" 
                        className={({ isActive }) =>
                            isActive ? "menuLink font-medium border-b border-[#ffee00] flex text-[#ffee00]" : "menuLink font-light text-[#ffee00] flex border-[#222222] hover:border-b border-slate]"
                        }>
                        <LayoutDashboard size={18}/><span className='m-0 ml-1'>dashboard</span>
                    </NavLink>
                    <NavLink to="projects" className={({ isActive }) =>
                        isActive ? "menuLink border-b border-[#ffee00] flex text-[#ffee00] ml-4" : "menuLink font-light ml-4 text-[#ffee00] flex border-[#222222] hover:border-b border-slate]"
                    }>
                        <AudioWaveform size={18}/><span className='m-0 ml-1'>projects</span>
                    </NavLink>
                    <NavLink to="clients" className={({ isActive }) =>
                        isActive ? "menuLink border-b border-[#ffee00] flex text-[#ffee00] ml-4" : "menuLink font-light ml-4 text-[#ffee00] flex border-[#222222] hover:border-b border-slate]"
                    }>
                        <Contact size={18}/><span className='m-0 ml-1'>clients</span>
                    </NavLink>
                    <NavLink onClick={props.logout} className={({ isActive }) =>
                        isActive ? "menuLink font-light flex text-[#ffee00] ml-4 hover:text-[#eeeeee]" : "menuLink font-light ml-4 text-slate-300 flex border-[#222222] hover:border-b border-slate]"
                    }>
                        <LogOut size={18}/><span className='m-0 ml-1'>logout</span>
                    </NavLink>
                </menu>

                <menu id="menu-dropdown" ref={dropdownRef} className="relative inline-block">
                    <button onClick={() => setMenuOpen(!menuOpen)} style={{ color: menuOpen ? "#bbbbbb" : "#ffee00" }}><AlignJustify /></button>
                    <div
                        id="menu-dropdown-content"
                        className={ menuOpen ? "absolute bg-slate-900 text-[#ffee00] z-10 visible" : " absolute bg-slate-900 text-[#ffee00] z-10 hidden" }
                    >
                        <NavLink
                            to="/"
                            className={({ isActive }) =>
                                isActive ? "menuLink font-medium border-b border-[#ffee00] flex text-[#ffee00]" : "menuLink font-light text-[#ffee00] flex hover:border-b border-slate]"
                            }
                            onClick={() => setMenuOpen(false)}
                        >
                            <LayoutDashboard /><span className='m-0'>dashboard</span>
                        </NavLink>
                        <NavLink
                            to="projects"
                            onClick={() => setMenuOpen(false)}
                            className={({ isActive }) =>
                                isActive ? "menuLink border-b border-[#ffee00] flex text-[#ffee00] ml-4" : "menuLink font-light ml-4 text-[#ffee00] flex hover:border-b border-slate]"
                            }
                        >
                            <ChartNoAxesGantt /><span className='m-0'>projects</span>
                        </NavLink>
                        <NavLink
                            to="clients"
                            onClick={() => setMenuOpen(false)}
                            className={({ isActive }) =>
                                isActive ? "menuLink border-b border-[#ffee00] flex text-[#ffee00] ml-4" : "menuLink font-light ml-4 text-[#ffee00] flex hover:border-b border-slate]"
                            }
                        >
                            <ChartNoAxesGantt /><span className='m-0'>clients</span>
                        </NavLink>
                        <NavLink
                            onClick={props.logout}
                            className={({ isActive }) =>
                                isActive ? "menuLink font-light flex text-[#ffee00] ml-4 hover:text-[#eeeeee]" : "menuLink font-light ml-4 text-slate-300 flex hover:border-b border-slate]"
                            }
                        >
                            <LogOut /><span className='m-0'>logout</span>
                        </NavLink>
                    </div>
                </menu>
            </header>
        </>
    );
};

export default Header;
